import { render, staticRenderFns } from "./dispshen.vue?vue&type=template&id=12b22056&"
import script from "./dispshen.vue?vue&type=script&lang=js&"
export * from "./dispshen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports